<template>
  <div>
    <a
      class="btn btn-sm btn-block btn-info text-white"
      data-target="#modalAddMinMax"
      data-toggle="modal"
      href="#"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Modificar o Asignar Tienda</span>
    </a>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddMinMax"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div
          class="modal-content color-scheme-dark"
          style="width: 100%; max-width: 100%"
        >
          <div class="modal-header faded smaller">
            <h5 class="text-success modal-title">Configuraciónes de tiendas</h5>
            <br />
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="element-wrapper">
              <div class="element-actions actions-only"></div>
              <div class="element-box-tp" style="padding: 0em !important">
                <table class="table table-compact smaller mb-0">
                  <thead>
                    <tr>
                      <th>Tienda</th>
                      <th class="text-center">estatus</th>
                      <th class="text-center">Auto</th>
                      <th class="text-center">Ajustes</th>
                      <th class="text-center">Compras</th>
                      <th class="text-center">Ventas</th>
                      <th class="text-center">Ingresos</th>
                      <th class="text-center">Salidas</th>
                      <th class="text-center">Devoluciones</th>
                      <th>Minmo</th>
                      <th>Maximo</th>
                      <th class="text-center">COmpra local</th>
                      <th class="text-right">Stock</th>
                      <th class="text-right"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="current_stock in tiendasfiltradas"
                      v-bind:key="current_stock.id"
                    >
                      <td>
                        <span>{{ current_stock.tienda }}</span>
                      </td>
                      <td class="text-center">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.activo"
                        />
                      </td>
                      <td class="text-center">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.sol_auto"
                        />
                      </td>
                      <td class="text-center text-bright">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.permitir_ajustes"
                        />
                      </td>
                      <td class="text-center text-bright">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.permitir_compras"
                        />
                      </td>
                      <td class="text-center text-bright">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.permitir_ventas"
                        />
                      </td>
                      <td class="text-center text-bright">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.permitir_ingresos_t"
                        />
                      </td>
                      <td class="text-center text-bright">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.permitir_salidas_t"
                        />
                      </td>
                      <td class="text-center text-bright">
                        <input
                          class="form-control"
                          type="checkbox"
                          v-model="current_stock.permitir_devoluciones"
                        />
                      </td>
                      <td class="text-right">
                        <input
                          type="text"
                          class="
                            form-control form-control-sm
                            text-dark text-right
                            font-weight-bold
                          "
                          style="height: 25px; width: 50px"
                          v-model="current_stock.minimo"
                        />
                      </td>

                      <td class="text-right text-bright">
                        <input
                          type="text"
                          class="
                            form-control form-control-sm
                            text-dark text-right
                            font-weight-bold
                          "
                          style="height: 25px; width: 50px"
                          v-model="current_stock.maximo"
                        />
                      </td>
                      <td class="text-center">
                        <input
                          type="checkbox"
                          v-model="current_stock.compra_local"
                        />
                      </td>
                      <td class="text-right">
                        <router-link
                          class="text-right text-success"
                          :class="{
                            'text-danger':
                              current_stock.existencia <= current_stock.minimo,
                            'text-warning':
                              current_stock.existencia > current_stock.maximo,
                          }"
                          :to="{
                            name: 'inventario-reportes-kardex',
                            params: {
                              sku: current_stock.producto,
                              tienda: current_stock.tienda,
                            },
                          }"
                          >{{ current_stock.existencia }}</router-link
                        >
                      </td>
                      <td
                        @click="modificarDetalle(current_stock)"
                        class="text-right"
                      >
                        <button class="btn btn-success btn-sm">
                          <i class="fas fa-save"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <small style="color: #ff9b00" class="font-weight-bold"
                  >Tomar en cuenta lo siguiente:
                  <br />
                  <i style="color: #00fff3" class="fas fa-info-circle"></i>
                  Cualquier modificación realizada en la configuración esta bajo
                  su propia responsabilidad.
                  <br />
                  <i style="color: #00fff3" class="fas fa-info-circle"></i>
                  Recuerde no modificar datos que no correspondan a su tienda de
                  trabajo, cualquier modificación realizada quedara registrada
                  con su información usuario.</small
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-success"
              @click="AgregarTiendaModal()"
              type="button"
            >
              Nueva Tienda
            </button>
            <button
              class="btn btn-warning"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddTienda"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content color-scheme-dark">
          <div class="modal-header faded smaller">
            <h5 class="text-success modal-title">Agregar Producto Tienda</h5>
            <br />
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="element-wrapper">
              <div class="row">
                <div class="col-4">
                  <TiendaSelectComponent :current="currentDetalle" />
                </div>
                <div class="col-4">
                  <label>Minimo</label>
                  <input
                    class="form-control"
                    type="number"
                    v-model="currentDetalle.minimo"
                  />
                </div>
                <div class="col-4">
                  <label>Maximo</label>
                  <input
                    class="form-control"
                    type="number"
                    v-model="currentDetalle.maximo"
                  />
                </div>
                <div class="col-3">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked
                        class="form-check-input"
                        v-model="currentDetalle.permitir_ajustes"
                        type="checkbox"
                        value="false"
                      />Ajutes
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.permitir_compras"
                        type="checkbox"
                        value="false"
                      />Compras
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.permitir_ventas"
                        type="checkbox"
                        value="false"
                      />Ventas
                    </label>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.permitir_ingresos_t"
                        type="checkbox"
                        value="false"
                      />Ingresos
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.permitir_salidas_t"
                        type="checkbox"
                        value="false"
                      />Salidas
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.permitir_devoluciones"
                        type="checkbox"
                        value="false"
                      />Devoluciones
                    </label>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.activo"
                        type="checkbox"
                        value="false"
                      />Activo
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked
                        class="form-check-input"
                        v-model="currentDetalle.sol_auto"
                        type="checkbox"
                        value="false"
                      />Sol Auto
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        v-model="currentDetalle.compra_local"
                        type="checkbox"
                        value="false"
                      />Compra Local
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-success"
              @click="AgregarTienda()"
              type="button"
            >
              Agregar tienda
            </button>
            <button
              class="btn btn-warning"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      currentDetalle: {
        minimo: 0,
        maximo: 0,
        sol_auto: false,
        permitir_ajustes: false,
        permitir_ventas: false,
        permitir_ingresos_t: false,
        permitir_salidas_t: false,
        permitir_devoluciones: false,
        activo: true,
        compra_local: false,
      },
      datos: {
        tiendas: [],
      },
    };
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
    filtrartienda: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tiendasfiltradas() {
      let self = this;
      if (self.current.productotienda_set) {
        return self.current.productotienda_set.filter((t) => {
          return self.filtrartienda == null || t.tienda == self.filtrartienda;
        });
      }
      return [];
    },
  },
  mounted() {},
  methods: {
    AgregarTienda() {
      this.currentDetalle.producto = this.current.sku;
      DynamicService.save("cat", "producto-tienda", this.currentDetalle)
        .then((response) => {
          Notifications.alert.success(
            "Asignar producto a tienda",
            "Ralizado correctamente"
          );
          $("#modalAddTienda").modal("hide");
          this.$emit("cerrandomodal");
        })
        .catch((error) => {
          Notifications.alert.error(
            "Asignar producto a tienda",
            error.response.data.detail
          );
        });
    },
    AgregarTiendaModal() {
      $("#modalAddMinMax").modal("hide");
      $("#modalAddTienda").modal("show");
    },
    modificarDetalle(d) {
      DynamicService.save("cat", "producto-tienda", d)
        .then((response) => {
          Notifications.alert.success(
            "Guardar Información",
            "Realizado exitosamente"
          );
        })
        .catch((error) => {
          alert("error");
        });
    },
  },
};
</script>
